import { DatePicker, Form, Input, Select } from 'antd'
import React, { useEffect, useState } from 'react'
import SelectField from '../../../common/Select/SelectField'
import { removeVietnameseTones } from '../../../../config-func'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({
  form,
  handleSearch,
  onChangePostType,
  ProductType,
  typeRealEstate,
  districts,
  towns,
  onChangeCity,
  cities,
  onChangeDistrict
}) => {
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 7 }}
      layout="vertical"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      onValuesChange={(value, allValues) =>
        console.log('Form Data', value, allValues)
      }
    >
      <Form.Item
        label={`Nhu cầu`}
        name="label"
        rules={[
          {
            required: true,
            message: 'Vui lòng chọn nhu cầu'
          }
        ]}
      >
        <Select
          placeholder="Chọn nhu cầu"
          options={[
            {
              value: 1,
              label: 'Thuê'
            },
            {
              value: 2,
              label: 'Bán'
            }
          ]}
        />
      </Form.Item>

      <Form.Item
        label={`Loại BĐS`}
        name="post_type"
        rules={[
          {
            required: true,
            message: 'Vui lòng chọn loại BĐS'
          }
        ]}
      >
        <Select
          placeholder="Chọn loại BĐS"
          onChange={onChangePostType}
          options={ProductType}
        />
      </Form.Item>

      <Form.Item
        label="Loại hình BĐS"
        name="type_real_estate"
        rules={[
          {
            required: true,
            message: 'Vui lòng chọn loại hình BĐS'
          }
        ]}
      >
        <Select placeholder="Chọn loại hình BĐS" options={typeRealEstate} />
      </Form.Item>
      
      <Form.Item
        label="Tỉnh/Thành phố"
        name="city_code"
        rules={[
          {
            required: true,
            message: 'Vui lòng chọn Tỉnh/Thành phố'
          }
        ]}
      >
        <Select
          placeholder="Chọn Tỉnh/Thành phố"
          onChange={onChangeCity}
          allowClear
          optionsFilterProp="children"
          showSearch
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase()
            const optionValue = removeVietnameseTones(
              option?.children || ''
            ).toLowerCase()
            return optionValue.includes(inputValue)
          }}
        >
          {cities.map((item) => {
            return (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            )
          })}
        </Select>
      </Form.Item>

      <Form.Item
        label="Quận/Huyện"
        name="district_code"
        rules={[
          {
            required: true,
            message: 'Vui lòng chọn Quận/Huyện'
          }
        ]}
      >
        <Select
          placeholder="Chọn Quận/Huyện"
          onChange={onChangeDistrict}
          allowClear
          optionsFilterProp="children"
          showSearch
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase()
            const optionValue = removeVietnameseTones(
              option?.children || ''
            ).toLowerCase()
            return optionValue.includes(inputValue)
          }}
        >
          {districts.map((item) => {
            return (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            )
          })}
        </Select>
      </Form.Item>

      <Form.Item
        label={`Phường/Xã/Thị trấn`}
        name="town_code"
        rules={[
          {
            required: true,
            message: 'Vui lòng chọn Phường/Xã/Thị trấn'
          }
        ]}
      >
        <Select
          placeholder="Chọn Phường/Xã/Thị trấn"
          allowClear
          optionsFilterProp="children"
          showSearch
          filterOption={(input, option) => {
            const inputValue = removeVietnameseTones(input).toLowerCase()
            const optionValue = removeVietnameseTones(
              option?.children || ''
            ).toLowerCase()
            return optionValue.includes(inputValue)
          }}
        >
          {towns.map((item) => {
            return (
              <Select.Option key={item.value} value={item.value}>
                {item.label}
              </Select.Option>
            )
          })}
        </Select>
      </Form.Item>
    </Form>
  )
}

export default FormPost
